import SingleDispute from "./SingleDisputeContainer";

export default SingleDispute;
